import { useDeviceSelect } from '@modules/reception/device-select'

export const useEservicePinPad = () => useDeviceSelect('eservice_pad_id')
